import ActionsMenu from "../../../components/ActionsMenu";
import React, { FC } from "react";
import { useField } from "react-final-form";
import SanitizedGrid from "../../../components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomMuiDataGrid from "../../../components/CustomMuiDataGrid";
import DetailRouteButton from "./DetailRouteButton";
import { calculateDurationInString } from "../tools";

interface AllRouteComponentProps {
  setIsOpenDetailRoute: any;
}

const AllRouteComponent: FC<AllRouteComponentProps> = ({
  setIsOpenDetailRoute,
}) => {
  const routeDataColumns = [
    {
      field: "routeName",
      headerName: "Route Name",
      width: 160,
    },
    {
      field: "totalStop",
      headerName: "Total Stops",
      width: 160,
      sortable: false,
      valueGetter: ({ row }: any) => row.routeLocations.length - 1, // because the one is the school location
    },
    {
      field: "totalStudents",
      headerName: "Total Students",
      width: 160,
      sortable: false,
      valueGetter: ({ row }: any) =>
        row.routeLocations.reduce(
          (total: number, location: any) => total + location.students.length,
          0,
        ),
    },
    {
      field: "durations",
      headerName: "Durations",
      width: 160,
      sortable: false,
      valueGetter: ({ row }: any) =>
        row.startTime && row.endTime
          ? calculateDurationInString(row.startTime, row.endTime)
          : "loading...",
    },
    {
      field: "routeColor",
      headerName: "Legend",
      width: 120,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div
            style={{
              backgroundColor: row.routeColor.colorTwo,
              width: "20px",
              height: "20px",
              borderRadius: 5,
            }}
          />
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      disableReorder: true,
      width: 320,
      renderCell: ({ row }: any) => {
        return (
          <ActionsMenu
            render={[
              <DetailRouteButton
                routeName={row.routeName}
                setIsOpenDetailRoute={setIsOpenDetailRoute}
              />,
            ]}
          />
        );
      },
    },
  ];

  const routesField = useField("routes");

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12} style={{ height: 500 }}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Routes
          </Typography>
        </Grid>

        <CustomMuiDataGrid
          key={routesField.input.value.length}
          sortModel={[
            {
              field: "routeName",
              sort: "asc",
            },
          ]}
          columnsToSearch={["routeName"]}
          rows={routesField.input.value}
          columns={routeDataColumns}
        />
      </Grid>
    </SanitizedGrid>
  );
};

export default AllRouteComponent;
